var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chatbot-block-editor run-javascript" },
    [
      _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("JavaScript Kodu"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "code-editor-wrapper" }, [
          _c("div", { staticClass: "code-editor-header" }, [
            _c("div", { staticClass: "tips" }, [
              _c(
                "div",
                { staticClass: "tip" },
                [
                  _c("md-icon", [_vm._v("info")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Bu blok, kullanıcının yazdığı JavaScript kodunu çalıştırır."
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tip" },
                [
                  _c("md-icon", [_vm._v("warning")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Güvenlik nedenlerinden dolayı bazı JavaScript özellikleri kısıtlanmıştır."
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions d-flex gap-5" },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "fullscreen-btn",
                    staticStyle: { "margin-right": "10px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.toggleFullScreen },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        staticStyle: {
                          "font-size": "15px",
                          "margin-right": "5px",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.isFullScreen
                                ? "fullscreen_exit"
                                : "fullscreen"
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.isFullScreen ? "Çıkış" : "Tam Ekran") +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "ai-assistant-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showPromptWizard },
                  },
                  [
                    _c("img", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        src: "/static/img/copilot.png",
                        width: "15",
                        height: "15",
                      },
                    }),
                    _vm._v(
                      "\n                        Supsis Asistan\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "code-editor" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", {
              staticClass: "monaco-editor-container",
              class: { "fullscreen-editor": _vm.isFullScreen },
              attrs: { id: "monaco-editor-container-chatbot" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "JavaScript Asistanı", width: 800, footer: null },
          on: { cancel: _vm.handleAssistantClose },
          model: {
            value: _vm.showJsAssistant,
            callback: function ($$v) {
              _vm.showJsAssistant = $$v
            },
            expression: "showJsAssistant",
          },
        },
        [
          _c("div", { staticClass: "js-assistant-modal" }, [
            _c("div", { staticClass: "js-assistant-description" }, [
              _c("h4", [_vm._v("JavaScript kodunu yapay zeka ile oluşturun")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                    Yapmak istediğiniz işlemi doğal dilde açıklayın, Supsis Asistan sizin için JavaScript kodunu\n                    oluştursun.\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "js-capabilities" }, [
                _c(
                  "div",
                  { staticClass: "capabilities-header" },
                  [
                    _c("a-icon", { attrs: { type: "bulb" } }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Yapabilecekleriniz:")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "capabilities-content" }, [
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("chat"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Mesaj gönderme")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("transfer_within_a_station"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Chat transfer")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Chat kapatma")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("http"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("API istekleri")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("person"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Kişi işlemleri")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("settings"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Attribute güncelleme")]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "prompt-container" },
              [
                _c("s2-textarea", {
                  ref: "promptTextarea",
                  attrs: {
                    rows: 4,
                    placeholder:
                      "Örnek: Kullanıcı adını al, selamla ve ardından email adresini kaydet",
                  },
                  model: {
                    value: _vm.jsPrompt,
                    callback: function ($$v) {
                      _vm.jsPrompt = $$v
                    },
                    expression: "jsPrompt",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "example-prompts" }, [
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "Kullanıcı adını al, mesajla selamla ve VIP olarak etiketle"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "user" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Kullanıcı selamlama ve etiketleme")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "Email adresi geçerli mi kontrol et, geçerli ise kaydet"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "mail" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Email doğrulama ve kaydetme")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "API ile sipariş durumunu kontrol et ve kullanıcıya bildir"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "api" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("API ile sipariş kontrolü")]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons-container" },
                  [
                    _c(
                      "a-button",
                      { on: { click: _vm.handleAssistantClose } },
                      [_vm._v("İptal")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.assistantLoading,
                        },
                        on: { click: _vm.generateJavaScriptCode },
                      },
                      [
                        _vm._v(
                          "\n                        Kod Oluştur\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "available-libraries" }, [
      _c("span", [_vm._v("Kullanılabilir Kütüphaneler:")]),
      _vm._v(" "),
      _c("code", [_vm._v("moment")]),
      _vm._v(", "),
      _c("code", [_vm._v("lodash (_)")]),
      _vm._v(", "),
      _c("code", [_vm._v("axios (sadece get ve post)")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "available-variables" }, [
      _c("span", [_vm._v("Kullanılabilir Değişkenler:")]),
      _vm._v(" "),
      _c("code", [_vm._v("chatbot.readAttribute")]),
      _vm._v(",\n                    "),
      _c("code", [_vm._v("chatbot.sendMessage")]),
      _vm._v(",\n                    "),
      _c("code", [_vm._v("chatbot.jump")]),
      _vm._v(",\n                    "),
      _c("code", [_vm._v("chatbot.askAssistant")]),
      _vm._v(",\n                    "),
      _c("code", [_vm._v("chatbot.platform")]),
      _vm._v(
        ",\n                    ve daha fazlası (chatbot. yazarak tüm metodları görebilirsiniz)\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "attribute-help" }, [
      _c("span", [_vm._v("Chatbot Değişkenleri:")]),
      _vm._v(" "),
      _c("code", [_vm._v("name")]),
      _vm._v(", "),
      _c("code", [_vm._v("email")]),
      _vm._v(", "),
      _c("code", [_vm._v("phone")]),
      _vm._v(", "),
      _c("code", [_vm._v("message")]),
      _vm._v(",\n                    "),
      _c("code", [_vm._v("block.blockId.field")]),
      _vm._v(" şeklinde kullanılabilir.\n                "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }